import { isEmbed } from 'src/common/consts'

export const generateShareLink = (offerId: string, networkName?: string) => {
  const origin = isEmbed ? 'https://app.swarm.com' : window.location.origin
  const pathname = '/discover/all-offers'

  return `${origin}${pathname}?id=${offerId}&chain=${networkName}`
}
